import { TrackingBaseResponse } from '@/reducers/tracking/types';
import api from '../config/api';
import {
  BannerRequest,
  BannerResponse,
  PointDetailResponse,
  TrackingRequest,
} from './types';

export const getBannerApi = (payload: BannerRequest) =>
  api.get<BannerResponse>(`/banners/${payload.bannerTag}`, {
    params: { retailerToken: payload.retailerToken },
  });

export const getPointDetailApi = (pointId: number) =>
  api.get<PointDetailResponse>(`/points/${pointId}`);

export const getTrackingInfoApi = (payload: TrackingRequest) =>
  api.get<TrackingBaseResponse>(`/tracking/${payload.pickitNumber}`, {
    headers: { Grecaptcharesponse: payload.recaptchaToken },
    params: {
      token: payload.retailerToken,
    },
  });
